import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {
  getEverydayRewardsEnrolmentStatusSuccess,
  getEverydayRewardsEnrolmentStatusFailure,
  getEverydayRewardsLoginUriSuccess,
  getEverydayRewardsLoginUriFailure,
  everydayRewardsConnectSuccess,
  everydayRewardsConnectFailure,
  everydayRewardsDisconnectSuccess,
  everydayRewardsDisconnectFailure,
} from '../actions/everydayRewardsActions';
import Env from '../Env';
import SURVEYS from '../constants/surveys';

function* getEverydayRewardsEnrolmentStatus(action) {
  const { grandParentAccountNumber, contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/loyalty/${contractIdentifier}/enrolment?grandParentAccountNumber=${grandParentAccountNumber}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getEverydayRewardsEnrolmentStatusSuccess(response));
  } catch {
    yield put(getEverydayRewardsEnrolmentStatusFailure());
  }
}

function* getEverydayRewardsLoginUri(action) {
  const { state } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/loyalty/loginUri?state=${state}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getEverydayRewardsLoginUriSuccess(response));
  } catch {
    yield put(getEverydayRewardsLoginUriFailure());
  }
}

function* everydayRewardsConnect(action) {
  const { grandparentAccountNumber, contractIdentifier, authorizationCode } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield call(fetchClient, {
      url: `accounts-api/v1/loyalty/${contractIdentifier}/connect?authorizationCode=${authorizationCode}&grandParentAccountNumber=${grandparentAccountNumber}`,
      method: 'POST',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(everydayRewardsConnectSuccess());
    if (Env.getIsZonkaEnabled() && typeof window._zf === 'function' && SURVEYS.LINKING_EVERYDAY_REWARDS_XERO_MYOB) {
      window._zf('startForm', { 'widgetId': SURVEYS.LINKING_EVERYDAY_REWARDS_XERO_MYOB, 'throttle': 'session' });
    }
  } catch {
    yield put(everydayRewardsConnectFailure());
  }
}

function* everydayRewardsDisconnect(action) {
  const { grandparentAccountNumber, contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield call(fetchClient, {
      url: `accounts-api/v1/loyalty/${contractIdentifier}/disconnect?grandParentAccountNumber=${grandparentAccountNumber}`,
      method: 'POST',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(everydayRewardsDisconnectSuccess());
  } catch {
    yield put(everydayRewardsDisconnectFailure());
  }
}

export default function* everydayRewardsSaga() {
  yield all([
    takeLatest(ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.REQUEST, getEverydayRewardsEnrolmentStatus),
    takeLatest(ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.REQUEST, getEverydayRewardsLoginUri),
    takeLatest(ActionTypes.EVERYDAY_REWARDS.CONNECT.REQUEST, everydayRewardsConnect),
    takeLatest(ActionTypes.EVERYDAY_REWARDS.DISCONNECT.REQUEST, everydayRewardsDisconnect),
  ]);
}
